// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchIocn[data-v-0604bf2d]{margin-top:10px;cursor:pointer}.mainContainer[data-v-0604bf2d]{overflow-x:auto;width:240px}.box-card[data-v-0604bf2d]{margin:10px 0;min-height:100px;overflow:auto;border:1px solid #dcdfe6;padding:10px}.item[data-v-0604bf2d],.selectItem[data-v-0604bf2d]{padding:5px 0;cursor:pointer;margin:5px 0}.selectItem[data-v-0604bf2d]{background-color:#d1eff3}", ""]);
// Exports
module.exports = exports;
